import { render, staticRenderFns } from "./AnalysesListSection.vue?vue&type=template&id=155c1bd4&scoped=true&"
import script from "./AnalysesListSection.vue?vue&type=script&lang=ts&"
export * from "./AnalysesListSection.vue?vue&type=script&lang=ts&"
import style0 from "./analyses-list.scss?vue&type=style&index=0&id=155c1bd4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "155c1bd4",
  null
  
)

export default component.exports